
import { UserModule } from '@/store/modules/user';
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import * as echarts from 'echarts';
import { Type } from '@/types/permissionType';
import { checkPermissionCompany, checkPermissionCompanyFromOrderType, checkPermissionRole } from '@/utils/permission';

@Component({
  name: 'WorkMenuList',
  components: {},
  filters: {
    getOrderStatusName(val: any) {
      let name = ''
      if (parseInt(val) > 0 && parseInt(val) < 3) {
        name = '待处理'
      } else if (parseInt(val) === 3 || parseInt(val) === 5) {
        name = '进行中'
      } else if (parseInt(val) === 7) {
        name = '已完成'
      } else if (parseInt(val) === 9) {
        name = '已关闭'
      }
      return name;
    }
  }
})
export default class extends Vue {
  @Prop({
    type: Object,
    default: {}
  })
  layout!: {};

  @Prop({
    type: Boolean,
    default: true
  })
  isDraggable!: Boolean
   @Prop({
     default: () => {}
   })
  layoutData!: any

  @Watch('layoutData', {
    deep: true,
    immediate: true
  })
   change() {
     this.dealData();
   }
   @Watch('layout', {
     deep: true,
     immediate: true
   })
  changeLayout() {
    this.dealData();
  }
  private permissionType = Type;

  private myChartsLine: any = null;
  private myChartsBar: any = null;
  private myChartsPie: any = null;
  private myChartsBarDevice: any = null;

  private orderData:any={};
  private toDoData:any={};
  private deptRankingData:any=[];
  private cusRankingData:any=[];
  private cusTransRankingData:any=[];
  private isClickDept:any=true;
  private deptAndCusTypeObj = {'dept':11,'cus':21,'cusTrans':22}
  private deptAndCusType :any = this.deptAndCusTypeObj.dept;

  private faultPhenomenonData:any=[];
  private faultData:any=[];

  private orderBBSData:any={};
  private linechart = {
    id: 1,
    name: '最近30天'
  }
  private linechartOptions: any = [{
    id: 1,
    name: '最近30天'
  }, {
    id: 3,
    name: '最近12个月'
  }, {
    id: 30,
    name: '当月'
  }, {
    id: 40,
    name: '当年'
  }]
  private orderPollingData:any={};
  private orderPollingTaskData:any=[];

  private deviceTOPData:any=[];

  private companyVersionData:any={};

  private dayList:any=[
    { id: 1,
      name: '当日'
    },
    { id: 2,
      name: '当周'
    },
    { id: 3,
      name: '当月'
    },
    { id: 4,
      name: '当年'
    }
  ]

  private deptData={
    id: 2,
    name: '当周'
  }
  private deviceDayData={
    id: 2,
    name: '当周'
  }
  private engDayData={
    id: 2,
    name: '当周'
  }
  private faultDayData={
    id: 2,
    name: '当周'
  }
  private isTitleToggle: any = 0
  private userName:string=UserModule.getUserName

  private depSelected = '3'
  private engineerList: any = []

  created() {
    // 上面的日历
    // this.dateList(this.dateNum);
    this.getToday();
  }

  private getShowCusRanking() {
    return checkPermissionCompany(UserModule.getCompanyId, Type.CUSTOMER_COMPANY)
  }
  private getShowCusTransRanking() {
    return checkPermissionCompany(UserModule.getCompanyId, Type.CUSTOMER_COMPANY)
  }
  get deptAndCusTypeData(){
    if (this.deptAndCusTypeObj.dept==this.deptAndCusType) {
      return this.deptRankingData;
    }else if(this.deptAndCusTypeObj.cus==this.deptAndCusType){
      return this.cusRankingData;
    }else{
      return this.cusTransRankingData;
    }
  }
  private checkPermissionCompanyFromOrderType(
    companyId: string,
    permission: Type,
    orderType: any
  ) {
    return checkPermissionCompanyFromOrderType(
      companyId,
      permission,
      orderType
    );
  }
  private checkPermissionUser(
    companyId: string,
    permission: Type
  ) {
    return checkPermissionRole(
      companyId,
      permission
    );
  }
  private checkPermissionCompany(companyId: string, permission: Type) {
    return checkPermissionCompany(companyId, permission);
  }
  private getDivision(val:any) {
    let aa = '0.00%';
    if (parseInt(val.all_order_num) !== 0) {
      aa = (parseInt(val.completed_order_num) / parseInt(val.all_order_num) * 100).toFixed(2) + '%';
    }
    return aa;
  }
  private getVersionData(val:any) {
    let aa:any = 0;
    aa = (parseInt(val) - parseInt(String(new Date().getTime() / 1000))) / 3600 / 24;
    return parseInt(aa);
  }

  private deptChange() {
    let pamars = {
      department_order_ranking_date_type: this.deptData.id,
      is_department_order_ranking: 1,
      department_order_ranking_type: this.depSelected,
    };
    this.$emit('pamars', pamars);
  }
  private deptDayChange(val:any) {
    let pamars:any = {};
    if (this.deptAndCusTypeObj.dept==this.deptAndCusType) {
      pamars.is_department_order_ranking = 1
      pamars.department_order_ranking_type = this.depSelected;
      pamars.department_order_ranking_date_type = this.deptData.id
    }  else if(this.deptAndCusTypeObj.cus==this.deptAndCusType){
      pamars.customer_ranking_type = this.deptData.id
      pamars.is_customer_order_ranking = 1
    }else{
      pamars.customer_ranking_type = this.deptData.id
      pamars.is_customer_order_trans_ranking = 1
    }
    this.$emit('pamars', pamars);
  }
  private cusOrderRankingClick(val:number) {
    this.deptAndCusType = val;
    let pamars:any = {};
    if (this.deptAndCusTypeObj.dept==this.deptAndCusType) {
      pamars.is_department_order_ranking = 1
      pamars.department_order_ranking_type = this.depSelected;
      pamars.department_order_ranking_date_type = this.deptData.id
    } else if(this.deptAndCusTypeObj.cus==this.deptAndCusType){
      pamars.customer_ranking_type = this.deptData.id
      pamars.is_customer_order_ranking = 1
    }else{
      pamars.customer_ranking_type = this.deptData.id
      pamars.is_customer_order_trans_ranking = 1
    }
    this.$emit('pamars', pamars);
  }
  private echartsDataLine() {
    let option = {
      color: ['#8DB9FC', '#18CA9B', '#BB89FB','rgb(255, 165, 0)','rgb(128, 128, 128)'],
      tooltip: {
        trigger: 'axis',
        axisPointer: {
          type: 'cross',
          label: {
            backgroundColor: '#6a7985'
          }
        }
      },
      legend: {
        data: [
          '进行中',
          '已完成',
          '全部',
          '未处理',
          '已关闭'
        ],
        left: 'left',
        itemWidth: 8,
        itemHeight: 8,
        itemGap: 30,
        icon: 'circle',
        lineStyle: {
          width: 0
        },
        textStyle: {
          fontSize: 16
        },
        selected: {
          '进行中': true,
          '已完成': true,
          '全部': true,
          '未处理': false,
          '已关闭': false
        }
      },
      grid: [
        {
          left: 30,
          right: 50,
          containLabel: true
        }
      ],
      toolbox: {
        show: false,
        top: 'bottom',
        feature: {
          dataView: {
            readOnly: false,
            show: true,
            title: '',
            lang: ['数据视图', '关闭', '刷新']
          },
          magicType: {
            title: '',
            type: ['line', 'bar']
          },
          restore: {},
          saveAsImage: {
            title: ''
          }
        },
        iconStyle: {
          borderColor: '#555'
        }
      },
      xAxis: {
        type: 'category',
        boundaryGap: false,
        data: this.orderData.line_char ? this.orderData.line_char.time : []
      },
      yAxis: {
        type: 'value'
      },
      series: [
        {
          name: '进行中',
          type: 'line',
          smooth: true,
          areaStyle: {
            opacity: 0.2,
            color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
              {
                offset: 0,
                color: 'rgb(141, 185, 252)'
              },
              {
                offset: 1,
                color: 'rgb(255, 255, 255)'
              }
            ])
          },
          data: this.orderData.line_char ? this.orderData.line_char.underway_order_num : []
        },
        {
          name: '已完成',
          type: 'line',
          smooth: true,
          areaStyle: {
            opacity: 0.2,
            color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
              {
                offset: 0,
                color: 'rgb(24, 202, 155)'
              },
              {
                offset: 1,
                color: 'rgb(255, 255, 255)'
              }
            ])
          },
          data: this.orderData.line_char ? this.orderData.line_char.finish_order_num : []
        },
        {
          name: '全部',
          type: 'line',
          smooth: true,
          areaStyle: {
            opacity: 0.2,
            color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
              {
                offset: 0,
                color: 'rgb(187, 137, 251)'
              },
              {
                offset: 1,
                color: '#fff'
              }
            ])
          },
          data: this.orderData.line_char ? this.orderData.line_char.all_order_num : []
        },
        {
          name: '未处理',
          type: 'line',
          smooth: true,
          areaStyle: {
            opacity: 0.2,
            color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
              {
                offset: 0,
                color: 'rgb(255, 165, 0)'
              },
              {
                offset: 1,
                color: 'rgb(255, 255, 255)'
              }
            ])
          },
          data: this.orderData.line_char ? this.orderData.line_char.untreated_order_num : []
        },
        {
          name: '已关闭',
          type: 'line',
          smooth: true,
          areaStyle: {
            opacity: 0.2,
            color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
              {
                offset: 0,
                color: 'rgb(128, 128, 128)'
              },
              {
                offset: 1,
                color: 'rgb(255, 255, 255)'
              }
            ])
          },
          data: this.orderData.line_char ? this.orderData.line_char.close_order_num : []
        }
      ]
    };
    option && this.myChartsLine && this.myChartsLine.setOption(option);
    // window.addEventListener('resize', () => {
    //   (document.querySelector('.line-echarts') as any).style.width = '100%';
    //   this.myChartsLine.resize();
    // });
  }

  private echartsDataBar(data:any) {
    let option = {
      tooltip: {},
      legend: {
        data: ['已完成', '全部订单'],
        left: '0'
      },
      title: [
        {
          text: '',
          left: 10,
          textAlign: 'left'
        }
      ],
      grid: [
        {
          top: 30,
          width: '90%',
          bottom: 10,
          left: 10,
          containLabel: true
        }
      ],
      xAxis: [
        {
          type: 'value',
          splitLine: {
            show: true
          },
          axisLine: {
            show: false
          },
          axisTick: {
            inside: true,
            lineStyle: {
              width: 0
            }
          }
        }
      ],
      yAxis: [
        {
          type: 'category',
          // data: Object.keys(topCompany.charts),
          axisLabel: {
            interval: 0,
            rotate: 30
          },
          splitLine: {
            show: false
          },
          axisLine: {
            lineStyle: {
              type: 'solid',
              color: '#18CA9B',
              width: '2'
            }
          },
          inverse: true
        }
      ],
      series: [
        {
          name: '全部订单',
          type: 'bar',
          barGap: '-100%',
          silent: true,
          itemStyle: {
            color: '#ECECEC'
          },
          barWidth: 20,
          data: data ? data.map(function(current: any) {
            return current.all_order_num;
          }) : []
        },
        {
          name: '已完成',
          type: 'bar',
          barGap: '-100%',
          itemStyle: {
            color: '#2AC99C'
          },
          // label: {
          //   position: 'right',
          //   show: true
          // },
          barWidth: 20,
          data: data ? data.map(function(current: any) {
            return current.completed_order_num;
          }) : []
        }
      ]
    };
    option && this.myChartsBar && this.myChartsBar.setOption(option);
    // window.addEventListener('resize', () => {
    //   this.myChartsBar.resize();
    // });
  }

  private echartsDataBarDevice() {
    let option = {
      tooltip: {
        trigger: 'axis',
        axisPointer: {
          type: 'shadow'
        }
      },
      title: {
        text: '工单数（单）'
      },
      grid: {
        left: '3%',
        right: '4%',
        bottom: '22px',
        containLabel: true
      },
      xAxis: [
        {
          show: true,
          type: 'category',
          data: this.deviceTOPData ? this.deviceTOPData.map(function(current: any) {
            return {
              value: current.device_name ? current.device_name : '',
              textStyle: {
                overflow: "breakAll",
                width: 80
              },
            };
          }) : [],
          axisLabel: {
            // rotate: 16,
            interval: 0
          },
          axisTick: false,
          axisPointer: {
            type: "none"
          }
        }
      ],
      yAxis: [
        {
          type: 'value',
          axisLine: {
            lineStyle: {
              type: 'solid',
              color: '#949494',
              width: '1'
            }
          },
          minInterval: 1,
          splitLine: {
            lineStyle: {
              type: 'dashed'
            }
          }
        }
      ],
      series: [
        {
          name: '全部订单',
          type: 'bar',
          itemStyle: {
            color: '#165DFF'
          },
          barWidth: 20,
          data: this.deviceTOPData ? this.deviceTOPData.map(function(current: any) {
            return current.device_order_num;
          }) : [],
        },
      ]
    };
    option && this.myChartsBarDevice && this.myChartsBarDevice.setOption(option);
    // window.addEventListener('resize', () => {
    //   this.myChartsBarDevice.resize();
    // });
  }

  private echartsDataPie() {
    let piedata:any = [
      { value: this.orderPollingData.executed_num, name: '已执行' },
      { value: this.orderPollingData.unexecuted_num, name: '未执行' }
    ];

    let option = {
      tooltip: {
        trigger: 'item'
      },
      legend: {
        itemWidth: 10,
        itemHeight: 10,
        icon: 'circle',
        bottom: 10,
        left: 0,
        itemGap: 30,
        formatter: function(name: any) {
          let data = piedata;
          let target;
          for (let i = 0, l = data.length; i < l; i++) {
            if (data[i].name === name) {
              target = data[i].value;
            }
          }
          return ['{a|' + target + '}', '{b|' + name + '}'].join('\n');
        },
        textStyle: {
          rich: {
            a: {
              color: '#041021',
              fontSize: 30,
              align: 'left',
              padding: [30, 0, 5, 6]
            },
            b: {
              color: '#878E9B',
              fontSize: 18,
              align: 'left',
              padding: [0, 0, 0, 6]
            }
          }
        }
      },
      series: [
        {
          name: '巡检执行率',
          type: 'pie',
          center: ['50%', 150],
          radius: ['50%', '65%'],
          avoidLabelOverlap: false,
          label: {
            show: true,
            fontSize: '22',
            position: 'center',
            formatter: function(name: any) {
              if (name.name === '已执行') {
                return [name.percent.toFixed(2) + '%', name.seriesName].join('\n');
              } else {
                return [(100 - name.percent).toFixed(2) + '%', name.seriesName].join('\n');
              }
            },
            lineHeight: 30
          },
          emphasis: {
            label: {
              show: true,
              fontSize: '22'
            }
          },
          labelLine: {
            show: false
          },
          data: piedata,

          color: ['#3081EF', 'rgba(48, 129, 239, .2)']

        }
      ]
    };
    option && this.myChartsPie && this.myChartsPie.setOption(option);
    // window.addEventListener('resize', () => {
    //   this.myChartsPie.resize();
    // });
  }
  private dealData() {
    if (this.layoutData) {
      if ('order_information' in this.layoutData) {
        this.orderData = this.layoutData.order_information;
      }
      if ('order_information' in this.layoutData) {
        this.orderData = this.layoutData.order_information;
      }
      if ('unfinish_order_information' in this.layoutData) {
        this.toDoData = this.layoutData.unfinish_order_information;
      }
      if ('order_information' in this.layoutData) {
        this.orderData = this.layoutData.order_information;
      }

      if ('department_order_ranking' in this.layoutData) {
        this.deptRankingData = this.layoutData.department_order_ranking
        if (document.getElementById('topbar-echarts')) {
          this.myChartsBar = echarts.init((document.getElementById('topbar-echarts') as any));
        }
        this.echartsDataBar(this.deptRankingData);
      }
      if ('customer_ranking' in this.layoutData) {
        this.cusRankingData = this.layoutData.customer_ranking
        if (document.getElementById('topbar-echarts')) {
          this.myChartsBar = echarts.init((document.getElementById('topbar-echarts') as any));
        }
        this.echartsDataBar(this.cusRankingData);
      }

      if ('customer_trans_ranking' in this.layoutData) {
        this.cusTransRankingData = this.layoutData.customer_trans_ranking
        if (document.getElementById('topbar-echarts')) {
          this.myChartsBar = echarts.init((document.getElementById('topbar-echarts') as any));
        }
        this.echartsDataBar(this.cusTransRankingData);
      }

      if ('order_bbs_information' in this.layoutData) {
        this.orderBBSData = this.layoutData.order_bbs_information;
      }

      if ('today_order_polling_information' in this.layoutData) {
        this.orderPollingData = this.layoutData.today_order_polling_information;
      }
      if ('order_polling_task_information' in this.layoutData) {
        this.orderPollingTaskData = this.layoutData.order_polling_task_information;
      }
      if ('device_ranking' in this.layoutData) {
        this.deviceTOPData = this.layoutData.device_ranking
      }
      if ('engineer_ranking' in this.layoutData) {
        this.engineerList = this.layoutData.engineer_ranking
      }
      if ('fault_type_statistics' in this.layoutData) {
        this.faultData = this.layoutData.fault_type_statistics;
      }
      if ('fault_phenomenon_statistics' in this.layoutData) {
        this.faultPhenomenonData = this.layoutData.fault_phenomenon_statistics;
      }

      if ('company_version_information' in this.layoutData) {
        this.companyVersionData = this.layoutData.company_version_information;
      }
      if (document.getElementById('line-echarts')) {
        this.myChartsLine = echarts.init((document.getElementById('line-echarts') as any));
        this.echartsDataLine();
      }

      if (document.getElementById('pie-echarts')) {
        this.myChartsPie = echarts.init((document.getElementById('pie-echarts') as any));
        this.echartsDataPie();
      }
      if (document.getElementById('topbar-device-echarts')) {
        this.myChartsBarDevice = echarts.init((document.getElementById('topbar-device-echarts') as any));
        this.echartsDataBarDevice();
      }
    }
  }

  private deviceDayChange(val:any) {
    let pamars = {
      device_ranking_type: val.id,
      is_device_ranking: 1
    };
    this.$emit('pamars', pamars);
  }
  private engDayChange(val:any) {
    let pamars = {
      engineer_ranking_type: val.id,
      is_engineer_ranking: 1
    };
    this.$emit('pamars', pamars);
  }
  private faultDayChange() {
    switch (this.isFaultToggle) {
      case 1:
        this.$emit('pamars', {
          fault_phenomenon_statistics_type: this.faultDayData.id,
          is_fault_phenomenon_statistics: 1
        });
        break
      case 2:
        this.$emit('pamars', {
          fault_type_statistics_type: this.faultDayData.id,
          is_fault_type_statistics: 1
        });
        break
    }
  }

  private swichOrderDate(val:any) {
    let pamars = {
      is_branch_company_order: this.isTitleToggle,
      order_information_type: val.id,
      is_order_information: 1
    };
    this.$emit('pamars', pamars);
  }
  private toChage() {
    this.$alert('', '请联系报修管家。联系电话：010-62111361', {
      confirmButtonText: '我知道了',
      center: true,
      callback: function() {

      }
    });
  }
  private moduleListClick(val:any) {
    if (!this.isDraggable) {
      if (val.jumpUrl) {
        this.$router.push({
          path: val.jumpUrl
        });
      }
    }
  }
  private deleteMenuHandle(val: any) {
    this.$emit('deleteMenu', val);
  }

  private isFaultToggle: number = 1
  private swichFault(val: any) {
    this.isFaultToggle = val.id
    switch (this.isFaultToggle) {
      case 1:
        this.$emit('pamars', {
          fault_phenomenon_statistics_type: this.faultDayData.id,
          is_fault_phenomenon_statistics: 1
        });
        break
      case 2:
        this.$emit('pamars', {
          fault_type_statistics_type: this.faultDayData.id,
          is_fault_type_statistics: 1
        });
        break
    }
  }
  private format(percentage: any) {
    return '';
  }
  private getPerCentage(item:any) {
    return (item.finish_task_num / item.all_task_num) * 100
  }

  private isAllAscending:number = 0;
  private isCompletedAscending:number = 0;
  private isClosedParmAscending: number = 0;
  private allUp() {
    this.isAllAscending = 1;
    // this.getEngineerList();
  }
  private allDown() {
    this.isAllAscending = 2;
    // this.getEngineerList();
  }
  private completedUp() {

  }
  private completedDown() {

  }
  private closedParmUp() {

  }
  private closedParmDown() {

  }
  // 上
  private value:any = "";
  private endDate = "";
  private dateRange: any = [];
  private dateNum = 0;

  // 获取当前时间的周一
  private getMonday(date: any) {
    let day = date.getDay();
    let deltaDay;
    if (day === 0) {
      deltaDay = 6;
    } else {
      deltaDay = day - 1;
    }
    var monday = new Date(date.getTime() - deltaDay * 24 * 60 * 60 * 1000);
    monday.setHours(0);
    monday.setMinutes(0);
    monday.setSeconds(0);
    return monday; // 返回选定时间的周一的0时0分0秒
  }
  private getDateNew(time: any) {
    let times = new Date(time);
    let year = times.getFullYear();
    let month = times.getMonth() + 1 < 10 ? "0" + (times.getMonth() * 1 + 1) : times.getMonth() * 1 + 1;
    let day = times.getDate() < 10 ? "0" + times.getDate() * 1 : times.getDate() * 1;
    return year + "-" + month + "-" + day;
  }
  private dateList(delta: any) {
    // 将时间对象转换为时间戳并加几天后转换为时间对象
    let DateNews = this.getMonday(
      new Date((new Date().getTime() / 1000 + 86400 * 7 * delta) * 1000)
    );
    let startDate = this.getDateNew(DateNews);
    this.endDate = this.getDateNew(
      new Date((DateNews.getTime() / 1000 + 6 * 86400) * 1000)
    );
    this.dateRange = [startDate, this.endDate];
  }
  private arrow(arrow: any) {
    if (arrow === "left") {
      this.dateNum--;
      this.dateList(this.dateNum);
    } else if (arrow === "right") {
      this.dateNum++;
      this.dateList(this.dateNum);
    }
  }
  private getPlanTask(val: any) {
    let pamars = {
      order_polling_task_job_time: val,
      is_order_polling_task_information: 1,
    };
    this.$emit('pamars', pamars);
  }
  private getToday() {
    let DateNews = this.getMonday(
      new Date()
    );
    let startDate = this.getDateNew(DateNews);
    let endDate = this.getDateNew(
      new Date((DateNews.getTime() / 1000 + 6 * 86400) * 1000)
    );
    this.dateRange = [startDate, endDate];
    this.value = new Date()
  }
  private toDeal(row:any) {
    this.$router.push({
      path: '/OrderServicer/todealing',
      query: {
        order_service_id: row.order_service_id,
        company_id: row.servicer_company_id
      }
    });
  }
  private jumpBBs(bbs:any) {
    this.$router.push({
      path: '/OrderServicer/todealing',
      query: {
        order_service_id: bbs.order_service_id,
        company_id: UserModule.getCompanyId
      }
    });
  }
  private bbsAll() {
    this.$router.push({
      path: '/Record/bbs',
      query:{
        enterType:'2'
      }
    })
  }
}
